import React, { FC } from "react";

import Image, { GIFS } from "../Image";

import { ElementWrapper } from "../Flex";

import { useMediaQuery } from "context/media/MediaContext";

import { ButtonProps } from "./Button.constants";
import { StyledButton, StyledLoadSpinner } from "./Button.styles";

const Button: FC<ButtonProps> = ({
  color = "primary",
  disabled = false,
  isLoading = false,
  block = false,
  type = "submit",
  text = "",
  onClick,
  children,
  IconSrc,
  IconWidth,
  IconHeight,
  width,
  height,
  autoFocus,
  float,
  margin,
  introIsOpen,
}) => {
  const { isMobile } = useMediaQuery();
  return (
    <StyledButton
      IconSrc={IconSrc}
      autoFocus={autoFocus}
      block={block}
      color={color}
      disabled={disabled}
      float={float}
      height={height}
      introIsOpen={introIsOpen}
      isLoading={isLoading}
      margin={margin}
      onClick={onClick}
      type={type}
      width={width}
    >
      {IconSrc && (
        <Image
          alt='Button Logo'
          height={IconHeight || "32px"}
          margin='0px 3px 0 0px'
          srcSet={IconSrc}
          width={IconWidth || "32px"}
        />
      )}

      {isLoading && <StyledLoadSpinner color={color} />}

      {introIsOpen && type === "submit" && (
        <ElementWrapper
          bottom='20%'
          mobileWidth='32px'
          position='absolute'
          right='15%'
          top='20%'
        >
          <Image
            alt='Button Intro Logo'
            borderRadius='99999px'
            height={isMobile ? "20px" : "32px"}
            srcSet={GIFS.HAND_TOUCH}
            width={isMobile ? "20px" : "32px"}
          />
        </ElementWrapper>
      )}

      {text || children}
    </StyledButton>
  );
};

export default Button;
